export function scientificNotationToString(num: number) {
  const numString = num.toString();

  // If the number is in scientific notation
  if (numString.includes('e')) {
    const parts = numString.split('e');
    const base = parts[0];
    const exponent = parseInt(parts[1], 10);

    if (exponent < 0) {
      // For negative exponents, pad with zeros
      const decimalPlaces = Math.abs(exponent) - 1;
      const result = '0.' + '0'.repeat(decimalPlaces) + base.replace('.', '');
      return result;
    } else {
      // For positive exponents, append zeros
      const integerPart = base.replace('.', '');
      const zerosToAdd = exponent - (integerPart.length - 1);
      const result = integerPart + '0'.repeat(zerosToAdd);
      return result;
    }
  }

  // If not in scientific notation, return as-is
  return numString;
}
